<template>


    <div>
      

         
 

               



 <section class="hero is-primary is-fullheight">
        <b-progress 
            type="is-success" 
            :value="valueProgressBar" 
            show-value
            rounded="false" 
            size="is-large"
            format="percent"
            v-show="showProgressBar"
        ></b-progress>

       


        <div class="hero-body">
            <div class="container has-text-centered">
                <div class="column is-4 is-offset-4">
                    <h3 class="title has-text-white">Login</h3>
                    <hr class="login-hr">
                    <p class="subtitle has-text-white">Please login to proceed.</p>
 
                     <form     @keyup.enter="pressEnter" class="box">
                      <div class="box">

                        <div class="image is-square">
                                <img src="@/assets/KU_SubLogo.png" 
                                style="opacity: 100;"
                                alt="Your Image">
                         </div>
                     
                        <form>
                            <div class="field">
                                 <div class="control has-icons-left">
                                        <input type="text" 
                                        placeholder="e.g. bobsmith@gmail.com" 
                                        class="input" 
                                        v-model="usrname" 
                                        required
                                        >
                                        <span class="icon is-small is-left">
                                        <i class="fa fa-user"></i>
                                        </span>
                                 </div>
                            </div>

                            <div class="field">
                                <div class="control">
                                   <b-input type="password"
                                                 v-model="passwd"
                                                 password-reveal
                                                 icon="lock-open"
                                                 placeholder="password"
                                        >
                                        </b-input>
                                </div>
                            </div>

                            <div class="field">
                              <small class="has-text-grey-light"><em>Version 2025.12.01.1</em></small>
                            </div>

                            <div class="field">
                                <label class="checkbox">
                
                </label>
                            </div>
                            <b-button type="is-info" expanded @click="doLogin">Login</b-button>
                            <!-- <b-button type="is-info" expanded @click="doLoginGetOTP">Login</b-button> -->
                        </form>
                      </div>
                     </form>  
                </div>
            </div>
        </div>
    </section>













        <b-loading  :active.sync="isFullScreenLoading" ></b-loading>




        <b-modal
                            v-if="isShowDlgGetOTP"
                            v-model="isShowDlgGetOTP"
                            has-modal-card
                           
                    >
            
                        <DlgGetOTP
                                v-if="isShowDlgGetOTP"
                                :resWithOTP="propsResWithOTP"

                                :usrname="propsUsrname"
                                :passwd="propsPasswd"
                                :fingerPrint="propsFingerPrint"
                                :clientIP="propsClientIP"
                                
                                @close = "closeDlgGetOTP"
                                @closeWithLoginSuccess= "closeDlgGetOTPWithLoginSuccess"
                        />
        </b-modal>  


    </div>


 


</template>

<script>
    /* eslint-disable no-console */
    import axios from "axios"
    import {mapActions, mapMutations , mapState} from "vuex";
    import {   getBaseURLforBackEnd  , getConfigAxios ,getBaseURLAvartar ,removeLocalStorage } from '@/utils.js'
    import sha512 from "js-sha512"
    import reloadMyJobsTray from "../../mixins/methods/reloadMyJobsTray";
    import DlgGetOTP from './DlgGetOTP/DlgGetOTP.vue'

    export default {
        name: "Login",
        mixins:[reloadMyJobsTray],
      
        components:{
            DlgGetOTP,
        },
        mounted() {
            // set user_id null every time to login
            this.produceUserID(null)
            // localStorage.removeItem('user_id');
            // localStorage.removeItem('user_name_surname');
            // localStorage.removeItem('refresh_token');
            // localStorage.removeItem('access_token');
            removeLocalStorage()
            this.produceSkip(0)
            this.clearListOfCytoResultRecently()
        },
        methods:{
            ...mapMutations({
                    setAccess_token: 'master_data/setAccess_token',
                    setUser_full_name_surname: 'master_data/setUser_full_name_surname',
                    setUserId: 'master_data/setUserId',
                }),

            ...mapActions({
                // produceAccessToken : 'master_data/produceAccessToken' ,
                produceUserID : 'master_data/produceUserID' ,
                produceUserName: 'master_data/produceUserName' ,
                fetchUserCustomizeCBCTbl : 'master_data/fetchUserCustomizeCBCTbl',
                produceUserAvartar :  'master_data/produceUserAvartar',
                produceUserIsAdmin : 'master_data/produceUserIsAdmin' ,
                produceUserRole : 'master_data/produceUserRole',

                fetchListOfCytoresultRecently : 'home/fetchListOfCytoresultRecently',
                fetchImagesRecently: 'home/fetchImagesRecently',

                fetchStatOfCBCLast7day : 'home/fetchStatOfCBCLast7day' ,
                fetchNewsArr : 'home/fetchNewsArr',
                fetchDocKind : 'master_data/fetchDocKind' ,
                fetchDocKindAll: 'master_data/fetchDocKindAll' ,
                produceSkip : 'home/produceSkip',
                clearListOfCytoResultRecently : 'home/clearListOfCytoResultRecently',
                fetchMyJobsTray: 'myjobstray/fetchMyJobsTray',
                clearListOHistoryOrders : 'listof_historyorders/clearListOHistoryOrders',
                fetchLabStaff : 'master_data/fetchLabStaff' ,
                fetchListOfDisableReason: 'master_data/fetchListOfDisableReason' ,
                fetchMiscMasterDataForBact: 'bact/fetchMiscMasterDataForBact' ,
                fetchMiscMasterDataForOrga: 'orga/fetchMiscMasterDataForOrga' ,
                fetchMiscMasterDataForPARA: 'parasite/fetchMiscMasterDataForPARA' ,
                fetchMytemplate : 'mytemplateTxt/fetchMytemplate' ,

                fetchPathologists : 'master_data/fetchPathologists' ,
                fetchParasitologist : 'master_data/fetchParasitologist' ,
                fetchStatusLabs : 'master_data/fetchStatusLabs' ,
                setupIDOPDTarget : 'opd_target/setupIDOPDTarget',


                fetchProvince : 'master_data/fetchProvince',
                fetchLab_his_lis_mapping : 'manually_create_lab_automate/fetchLab_his_lis_mapping',

                fetchArrUsers: 'manually_create_lab_automate/fetchArrUsers' ,
            }),


            pressEnter(){
                this.doLogin()  
            },


            countProgress(){
                              this.valueProgressCountStep++
                              this.valueProgressBar =
                               (this.valueProgressCountStep /this.valueProgressBarTotal  )  *100
            },  

           async doAfterSuccessToLogin(res_data){
                         
                         
                        this.isFullScreenLoading = true
                        this.showProgressBar = true
                        this.valueProgressBar = 0
                        
                        localStorage.setItem('access_token',res_data.access_token)
                        localStorage.setItem('refresh_token',res_data.refresh_token)

                        
                        
                     await   this.setAccess_token(res_data.access_token)
                      this.countProgress()
                    
                     await   this.fetchLabStaff()
                      this.countProgress()
                     await   this.setUserId(res_data.user_id)
                      this.countProgress()
                        // this.produceUserID(res_data.user_id)
                     await   this.produceUserName(this.usrname)
                      this.countProgress()
                     await   this.produceUserIsAdmin(res_data.isadmin)
                      this.countProgress()
                     await    this.produceUserRole(res_data.user_role)
                      this.countProgress()
                     await   this.setUser_full_name_surname(res_data.user_name_surname)
                      this.countProgress()
                        localStorage.setItem('user_id',res_data.user_id)
                        localStorage.setItem('user_name_surname',res_data.user_name_surname)


                    await   this.produceSkip(0)
                            this.countProgress()
                    await   this.clearListOfCytoResultRecently()
                            this.countProgress() 
                    await   this.fetchListOfCytoresultRecently({"first":this.first,"skip":this.skip})
                            this.countProgress()

                    await   this.fetchImagesRecently()
                            this.countProgress()


                    await    this.fetchStatOfCBCLast7day()
                             this.countProgress() 
                    await    this.fetchNewsArr()
                             this.countProgress()
                         
                    await    this.fetchDocKindAll()
                             this.countProgress()
                    await    this.reloadMyJobsTray()
                             this.countProgress()
                    await    this.clearListOHistoryOrders()
                             this.countProgress()
                    await    this.fetchListOfDisableReason()
                             this.countProgress()

                    await    this.fetchLab_his_lis_mapping()
                             this.countProgress() 

                    await    this.fetchPathologists()
                             this.countProgress()
                    await    this.fetchParasitologist()
                             this.countProgress()
                    await    this.fetchStatusLabs()
                             this.countProgress() 
                    await    this.fetchDocKind()
                             this.countProgress()

                    await    this.fetchMiscMasterDataForBact({ "admin":false,
                                                        "want_bact": true,
                                                        "want_drugs": true,
                                                        "want_template": true,
                                                        "want_mic": true,
                                                        "want_result_mst" : true,
                                                        "want_method_mst": true,
                                                        "want_method_result_mst": true,
                                                       })
                             this.countProgress()                          
                    await    this.fetchMiscMasterDataForOrga({ "admin":false,
                                                        "want_bact": true,
                                                        "want_drugs": true,
                                                        "want_template": true,
                                                        "want_mic": true,
                                                        "want_result_mst" : true,
                                                        "want_method_mst": true,
                                                        "want_method_result_mst": true,
                                                      })
                             this.countProgress() 
                    await    this.fetchMiscMasterDataForPARA({ "admin":false,
                                                        "want_bact": true,
                                                        "want_drugs": false,
                                                        "want_template": true,
                                                        "want_mic": true,
                                                        "want_result_mst" : true,
                                                        "want_method_mst": true,
                                                        "want_method_result_mst": true,
                                                      })
                             this.countProgress()                         
                                                      
                                                      


                        if(res_data.avartar_path) {
                            const urlAvartar = `${getBaseURLAvartar()}/user_${res_data.user_id}/${res_data.avartar_path}`
                            await this.produceUserAvartar(urlAvartar)
                                  this.countProgress()
                            localStorage.setItem('urlAvartar', urlAvartar)
                        }else {
                            await this.produceUserAvartar("")
                                  this.countProgress()
                            localStorage.setItem('urlAvartar', "")
                        }
                        await this.fetchMytemplate({user_id : res_data.user_id})
                              this.countProgress()
                        await this.fetchProvince()
                              this.countProgress()

                        await this.fetchArrUsers()
                              this.countProgress() 


                        // this.isFullScreenLoading = false
                        //****************************
                        await this.$buefy.toast.open({
                            duration: 1500,
                            message: `Login successful`,
                            position: 'is-top',
                            type: 'is-success'
                        })
                        // return true
                        // console.log("this.user_id--> ",this.user_id)
                        if (this.user_id) {
                                await this.fetchUserCustomizeCBCTbl(this.user_id)
                                await this.$buefy.snackbar.open({
                                        duration: 1000,
                                        message:` Load User Information Completed `,
                                        type: 'is-success',
                                        position: 'is-bottom-left',
                                    })
                                await this.$router.push('/')
                                this.isFullScreenLoading = false
                                this.showProgressBar = false
                        }

                        // if(res) {

                        //         if (this.user_id) {
                        //             this.fetchUserCustomizeCBCTbl(this.user_id)
                        //             this.$buefy.snackbar.open({
                        //                     duration: 1000,
                        //                     message:` Load User Information Completed `,
                        //                     type: 'is-success',
                        //                     position: 'is-bottom-left',
                        //                 })
                        //         }else{
                        //             this.$router.push('/login')
                        //                 .catch(()=>{});
                        //         }
                        //         this.$router.push('/')
                        // }
            },
            
            
            closeDlgGetOTPWithLoginSuccess(payload){
                 
                this.doAfterSuccessToLogin(payload)
                this.isShowDlgGetOTP = false 
            },
            closeDlgGetOTP(){
                 this.isShowDlgGetOTP = false 
            },
            async doLoginGetOTP(){
                const vm = this
                this.isFullScreenLoading = true
                const dat =   {
                    "username" : this.usrname,
                    "password" : sha512(sha512(this.passwd)),
                    "fp": this.fingerPrint,
                    "ip": this.clientIP,
                    "kick": "Y"
                } 

                await   axios.post(`${getBaseURLforBackEnd()}/api/loginbeforeotp`,dat,getConfigAxios())
                    .then((res) => {
                        // console.log(JSON.stringify(res.data))
                        this.isFullScreenLoading = false 
                        this.propsResWithOTP = Object.assign({},res.data)
                        this.propsUsrname = this.usrname,
                        this.propsPasswd = sha512(sha512(this.passwd)),
                        this.propsFingerPrint =  this.fingerPrint
                        this.propsClientIP =  this.clientIP
                        this.isShowDlgGetOTP = true
                    })

                    .catch(function(error) {
                        // console.log("loginbeforeotp error")
                        vm.isFullScreenLoading = false
                        vm.$buefy.toast.open({
                            duration: 5000,
                            message: `Some error to ${error}`,
                            position: 'is-top',
                            type: 'is-danger'
                        })

                        if (error.response && error.response.status === 401) {
                            this.isLoginIncorrect = true
                            setTimeout(()=>{
                                vm.isLoginIncorrect = false
                                vm.isFullScreenLoading = false
                            },1000)
                        }

                    });

                 
            },









            async   doLogin(){

                const dat =   {
                    "username" : this.usrname,
                    "password" : sha512(sha512(this.passwd)),
                    "fp": this.fingerPrint,
                    "ip": this.clientIP,
                    "kick": "Y"
                }

               
                const vm = this
                this.isLoginIncorrect = false
                this.isFullScreenLoading = true
                // const res =await   axios.post(`${getBaseURLforBackEnd()}/api/login1`,dat,getConfigAxios())
                //   await   axios.post(`${getBaseURLforBackEnd()}/api/login1`,dat,getConfigAxios())
                // console.log("test")
                await   axios.post(`${getBaseURLforBackEnd()}/api/userlogin_webpatho`,dat,getConfigAxios())
                    .then((res) => {
                         vm.doAfterSuccessToLogin(res.data)
                        // localStorage.setItem('access_token',res.data.access_token)
                        // localStorage.setItem('refresh_token',res.data.refresh_token)

                        
                        
                        // vm.setAccess_token(res.data.access_token)
                        // vm.fetchLabStaff()
                        // vm.produceUserID(res.data.user_id)
                        // vm.produceUserName(this.usrname)
                        // vm.produceUserIsAdmin(res.data.isadmin)
                        // vm.produceUserRole(res.data.user_role)
                        // vm.setUser_full_name_surname(res.data.user_name_surname)
                        // localStorage.setItem('user_id',res.data.user_id)
                        // localStorage.setItem('user_name_surname',res.data.user_name_surname)


                        // vm.produceSkip(0)
                        // vm.clearListOfCytoResultRecently()
                        // vm.fetchListOfCytoresultRecently({"first":vm.first,"skip":vm.skip})

                        // vm.fetchImagesRecently()


                        // vm.fetchStatOfCBCLast7day()
                        // vm.fetchNewsArr()
                         
                        // vm.fetchDocKindAll()
                        // vm.reloadMyJobsTray()
                        // vm.clearListOHistoryOrders()
                        // vm.fetchListOfDisableReason()

                        // vm.fetchLab_his_lis_mapping()

                        // vm.fetchPathologists()
                        // vm.fetchParasitologist()
                        // vm.fetchStatusLabs()
                        // vm.fetchDocKind()

                        // vm.fetchMiscMasterDataForBact({ "admin":false,
                        //                                 "want_bact": true,
                        //                                 "want_drugs": true,
                        //                                 "want_template": true,
                        //                                 "want_mic": true,
                        //                                 "want_result_mst" : true,
                        //                                 "want_method_mst": true,
                        //                                 "want_method_result_mst": true,
                        //                                })
                        // vm.fetchMiscMasterDataForOrga({ "admin":false,
                        //                                 "want_bact": true,
                        //                                 "want_drugs": true,
                        //                                 "want_template": true,
                        //                                 "want_mic": true,
                        //                                 "want_result_mst" : true,
                        //                                 "want_method_mst": true,
                        //                                 "want_method_result_mst": true,
                        //                               })

                        // vm.fetchMiscMasterDataForPARA({ "admin":false,
                        //                                 "want_bact": true,
                        //                                 "want_drugs": false,
                        //                                 "want_template": true,
                        //                                 "want_mic": true,
                        //                                 "want_result_mst" : true,
                        //                                 "want_method_mst": true,
                        //                                 "want_method_result_mst": true,
                        //                               })
                                                      
                                                      


                        // if(res.data.avartar_path) {
                        //     const urlAvartar = `${getBaseURLAvartar()}/user_${res.data.user_id}/${res.data.avartar_path}`
                        //     vm.produceUserAvartar(urlAvartar)
                        //     localStorage.setItem('urlAvartar', urlAvartar)
                        // }else {
                        //     vm.produceUserAvartar("")
                        //     localStorage.setItem('urlAvartar', "")
                        // }
                        // vm.fetchMytemplate({user_id : res.data.user_id})

                        // vm.fetchProvince()


                        // vm.fetchArrUsers()



                        // vm.isFullScreenLoading = false
                        // //****************************
                        // vm.$buefy.toast.open({
                        //     duration: 1500,
                        //     message: `Login successful`,
                        //     position: 'is-top',
                        //     type: 'is-success'
                        // })
                        // return true
                    })
                    // .finally(()=>{
                    //     vm.isFullScreenLoading = false
                    // })
                    .catch(function(error) {
                        vm.isFullScreenLoading = false
                        vm.$buefy.toast.open({
                            duration: 5000,
                            message: `Some error to ${error}`,
                            position: 'is-top',
                            type: 'is-danger'
                        })

                        if (error.response && error.response.status === 401) {
                            vm.isLoginIncorrect = true
                            setTimeout(()=>{
                                vm.isLoginIncorrect = false
                                vm.isFullScreenLoading = false
                            },1000)
                        }

                    });



                // init some parameter
                // if(res) {

                //     if (this.user_id) {
                //         this.fetchUserCustomizeCBCTbl(this.user_id)
                //         this.$buefy.snackbar.open({
                //                 duration: 1000,
                //                 message:` Load User Information Completed `,
                //                 type: 'is-success',
                //                 position: 'is-bottom-left',
                //             })
                //     }else{
                //         this.$router.push('/login')
                //             .catch(()=>{});
                //     }
                //     this.$router.push('/')
                // }

            }

        },
        computed: {
            ...mapState({
                user_id : state => state.master_data.user_id ,
                fingerPrint: state => state.master_data.fingerPrint,
                clientIP: state => state.master_data.clientIP,
                first: state => state.home.first,
                skip: state => state.home.skip,
                step: state => state.home.step,
            })
        },
        data() {
            return {
                //8af1d99383ea497d2cb0efedea55de1b3d3777c5086018db648480497a7c9a8edd79b648cdd655f221c4c5ac340208a190361975783fd6d9304dcdde75265b86
                //05aca5a0cbd6e6811fb2252e96d0f37d5e45571d2dba57c0c9774c023e8f377a24b4e2ed85bc4ac4d54fee4296cd96df4925e248e23eb02ed9571488dd704a19
               //     usrname : 'kannika.si@ku.th',
                // usrname:  'supreeya.ss@ku.th',
                // usrname : 'fvetwy0p@k?u.ac.th',
                // usrname : 'kanokwan.ch@ku.th',
                // usrname : 'phudit.m@ku.th',
                // usrname : "test@hotmail.com",
                // usrname : "wachiraphan.s@ku.th" ,
                // usrname :  'fvetjpn@ku.ac.th' , 
              //      usrname : 'sompohj@gmail.com',
                //    usrname : 'burin.n@ku.th',
                // usrname : 'fvetwyp@ku.ac.th',
               // usrname : 'Fvetkpk@ku.ac.th',
               //   passwd : 'LydibomiN',
              usrname : '',
              passwd : '',
                hasError: false,
                isLoginIncorrect : false,
                isFullScreenLoading : false,


                showProgressBar : false,
                valueProgressBar : 0,
                valueProgressBarTotal : 34 ,
                valueProgressCountStep : 1 ,

                isShowDlgGetOTP : false,
                propsResWithOTP : {},
                propsUsrname : "",
                propsPasswd : "",
                propsFingerPrint : "",
                propsClientIP : "",

            }
        }
    }



 



</script>

<style scoped>
/* .image img {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
} */
</style>